module.exports = __webpack_public_path__ + "img/cart-valid.34618775.svg";